import React, { Component } from "react";
import * as HTTPServices from "../../../../../../api/HTTPServices";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Button, Box, Typography, IconButton } from "@mui/material";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload'; import FolderIcon from '@mui/icons-material/Folder';
import * as Helper from "../../../../../../helpers/helper";
import DeleteIcon from '@mui/icons-material/Delete';
class AddAttachFile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: "",
      file: "",
      fileList: [],
      loading: false,
      disabled: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    switch (event.target.name) {
      case "text":
        this.setState({ text: event.target.value });
        break;
      case "file":
        const filesArray = Array.from(event.target.files);
   
        if (this.state.fileList.length < 5) {
          this.setState(
            {
              file: event.target.value,
              fileList: [...filesArray, ...this.state.fileList],
            }
          )
        } else {
          Helper.ErrorData("در مرحله حداکثر ۵ فایل قابل ارسال می باشد.");
        }

        break;
      default:
        break;
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    var LiveObject = this;
    LiveObject.setState({
      loading: true,
    });

    const { AudienceID, VisitToken, AddFile } = this.props;
    // var Submit = document.getElementById("Submit");
    // Submit.disabled = true;
    // Submit.innerText = "در حال ثبت ، لطفا صبر کنید...";

    var formData = new FormData();
    formData.append("message", this.state.text);
    formData.append("audience", AudienceID);
    formData.append("room_token", VisitToken);
    formData.append("length", this.state.fileList.length);
    formData.append("type", "dossierFile");
    for (let i = 0; i < this.state.fileList.length; i++) {
      console.log("num",i)
      formData.append(`file${i}`, this.state.fileList[i]);
    }

    // var Submit = document.getElementById("Submit");
    // Submit.disabled = true;

    const RequestService = HTTPServices.postMethod(
      "FileSend",
      formData,
      "true"
    );
    RequestService.then(function (response) {
      // Submit.disabled = false;

      if (response) {
        console.log("taha 2",response)
        AddFile(response.data);
        // LiveObject.setState({
        //   text: "",
        //   loading: false,
        //   // chats: [...LiveObject.state.chats, response.message],
        //   // selectedToReply: "",
        //   // showReplyDiv: false,
        // });
      } else {
        // Submit.disabled = false;
        LiveObject.setState({
          loading: false,
        });
      }
    }).catch((error) => {
      console.log(error, 'error');
      // Submit.disabled = false;
      LiveObject.setState({
        loading: false,
      });
    });
  }

   handleClickDelete(files){
    const filesFilter=this.state.fileList.filter(item=>item.name!==files.name)
    this.setState({fileList:filesFilter})
  }


  render() {
    return (
      <div className="attach_new_file">
        <div className="fs_split_pane large_bottom_margin">
          <form className="form-horizontal" onSubmit={this.handleSubmit}>
            {this.state.loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <>
                <div className="box_input">
                  <textarea
                    style={{ backgroundColor: "#eee", height: "10rem" }}
                    name="text"
                    className="form-control"
                    placeholder="توضیحات کامل"
                    value={this.state.text}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="box_input" style={{ display: "flex", flexDirection: "column", gap: "0.5rem", justifyContent: "center", alignItems: "center" }}>
                  {/* <label className="label_sbm" form="file">
                    فایل ارسالی : تصویر
                  </label> */}
                  <label style={{
                    display: "flex", justifyContent: "center", textAlign: "center", marginX: "auto"
                  }}>
                    <input
                      style={{ display: "none" }}
                      multiple
                      id="file"
                      name="file"
                      className="form-control"
                      type="file"
                      disabled={this.state.disabled}
                      onChange={this.handleChange}
                      required
                      accept="image/jpg, image/jpeg, image/png, application/pdf"
                    />
                    <Button id="file" component="span" disabled={this.state.disabled} sx={{
                      backgroundColor: "#eee !important",
                      padding: "2rem !important",
                      height: "10rem",
                      width: "10rem",
                      borderRadius: "10px !important",
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.5rem",
                      fontSize: "1.5rem !important",
                      color: "#7747c0 !important"
                    }}>
                      <DriveFolderUploadIcon sx={{ color: "#7747c0", fontSize: "2rem !important" }} />
                      آپلود فایل
                    </Button>
                  </label>
                  <p className="help_text" style={{ marginBottom: "0", display: "flex", flexDirection: "column" ,justifyContent:"center",textAlign:"center"}}>
                    فایل های قابل قبول:png , jpeg , jpg  ,pdf
                    <span sx={{color:"#de0036 !important"}}>
                    در هر مرحله حداکثر ۵ فایل قابل ارسال می باشد
                    </span>
                  </p>

                  {this.state.fileList.map(files => (
                    <Box key={files.name} sx={{
                      background: "#eee",
                      display: "flex",
                      borderRadius: "10px",
                      width: "100%",
                      paddingY: "1rem",
                      justifyContent: "space-between !important"
                    }}>
                      <Box sx={{ display: "flex", alignItems: "center", color: "#7747c0", width: "80%", marginX: "auto", gap: "1rem" ,justifyContent:"space-between"}}>
                        <Box sx={{display:"flex",alignItems:"center",gap:"0.5rem"}}>
                          <FolderIcon sx={{ marginTop: "0.25rem" }} />
                          <Typography>{files.name.slice(0, 10)}... .{files.name.split(".")[1]}</Typography>
                        </Box>
                        <IconButton onClick={()=>this.handleClickDelete(files)}><DeleteIcon sx={{color:"#7747c0"}}/></IconButton>
                      </Box>
                    </Box>
                  ))}
                </div>

                <div className="box_conferm" style={{
                  display: "flex", justifyContent: "center", textAlign: "center", marginX: "auto"

                }}>
                  <button
                    id="SubmitّItem"
                    className="button"
                    type="submit"
                  >
                    تایید و ارسال
                  </button>
                </div>
              </>
            )}
          </form>
        </div>
      </div>
    );
  }
}

export default AddAttachFile;
